export enum LeaderboardTab
{
  Global  = "Global",
  Country = "Country",
}
